import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Step.module.css";
import NavButton from "./NavButton";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import structure from "../../../assets/dashboard/structure.svg";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import info from "../../../assets/componentAssets/info.svg";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import {
  structure_type,
  structure as newStructure,
  constructionType,
  wing,
  coolingSystem,
  outsideAir,
} from "../utility/utils";
import { PatchApi, PostApi, getApi } from "../../../Utility/network";
import CustomCheckBox from "../../../Components/CustomCheckBox/CustomCheckBox";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import {
  arrayId,
  convertCommaToDot,
  convertDotToComma,
  onlyId,
} from "../../../Utility/utils";
import { useNavigate } from "react-router-dom";
import DialogAdd from "../../../Components/DialogAdd/DialogAdd";
import { selectedLanguage, stringToYYYYMMDD } from "../../../Utility/helper";
import { needCertificateEngText } from "../../../Utility/engLangObject";
import { needCertificateGerText } from "../../../Utility/gerLangObject";
import styled from "@emotion/styled";
import DateField from "../../../Components/DateField/DateField";

function Step2() {
  const { setState, state, HandleErrorPop } = useContext(AppContext);
  const { language, needLanguage } = state;
  const navigate = useNavigate();
  const [errorsData, setErrorsData] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [notes, setNotes] = useState(null);
  const [review, setReview] = useState({ review: [] });
  const [infoText, setInfoText] = useState([]);
  const [pop, setPop] = useState();
  const [type, setType] = useState(1);
  const [ventilation, setVentaltion] = useState([]);
  const [material, setMaterial] = useState([]);
  const [struct, setStruct] = useState({ id: null, wall_details: [] });
  const [corners, setCorners] = useState(4);
  const [response, setResponse] = useState(false);
  const [disableNext, setDisableNext] = useState(true);
  const [submitData, setSubmitData] = useState({
    is_there_cooling_system: false,
    is_test_for_leaks_conducted: false,
    outside_air_exchange: null,
    type_of_cooling_system_used_id: null,
    average_total_floor_height: null,
    living_space: null,
    construction_type: null,
    material_id: null,
    wing: null,
    ventilation_id: [],
    position_of_ventilation: null,
    next_inspection_date: "",
    cooling_capacity: null,
    number_of_air_conditioning_systems: 0,
  });
  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };

  const [numberOfColling, setNumberOfColling] = useState([
    { id: 0, title: " 0" },
    { id: 1, title: " 1" },
    { id: 2, title: " 2" },
    { id: 3, title: " 3" },
    { id: 4, title: " 4" },
    { id: 5, title: " 5" },
    { id: 6, title: " 6" },
    { id: 7, title: " 7" },
    { id: 8, title: " 8" },
    { id: 9, title: " 9" },
    { id: 10, title: "10" },
  ]);

  const [coolingData, setCoolingData] = useState([]);
  // useEffect(() => {
  //   if (state?.walls?.structure_detail?.hasOwnProperty("id")) {
  //     const { structure_detail } = state.walls;
  //     const {
  //       average_total_floor_height,
  //       construction_type,
  //       is_test_for_leaks_conducted,
  //       is_there_cooling_system,
  //       material,
  //       outside_air_exchange,
  //       structure_type,
  //       wall_details,
  //       wing,
  //       ventilation,
  //       living_space,
  //       type_of_cooling_system_used,
  //     } = state?.walls?.structure_detail;
  //     setSubmitData({
  //       average_total_floor_height,
  //       construction_type,
  //       is_test_for_leaks_conducted,
  //       is_there_cooling_system,
  //       material_id: onlyId(material),
  //       outside_air_exchange,
  //       wing,
  //       ventilation_id: arrayId(ventilation),
  //       type_of_cooling_system_used_id: arrayId(type_of_cooling_system_used),
  //       living_space,
  //     });
  //     setStruct({ id: structure_type, wall_details: wall_details });
  //     setType(structure_type);
  //   }
  // }, [state]);
  useEffect(() => {
    if (state?.walls?.structure_detail?.hasOwnProperty("id")) {
      const { structure_detail } = state.walls;
      const {
        average_total_floor_height,
        construction_type,
        is_test_for_leaks_conducted,
        is_there_cooling_system,
        material,
        outside_air_exchange,
        structure_type,
        wall_details,
        wing,
        ventilation,
        living_space,
        type_of_cooling_system_used,
      } = structure_detail;

      setSubmitData((prev) => ({
        ...prev,
        average_total_floor_height:
          language === "de"
            ? convertDotToComma(
                average_total_floor_height
                  ? average_total_floor_height.toString()
                  : ""
              )
            : average_total_floor_height,
        construction_type,
        is_test_for_leaks_conducted,
        is_there_cooling_system,
        material_id: onlyId(material),
        outside_air_exchange,
        wing,
        ventilation_id: arrayId(ventilation),
        type_of_cooling_system_used_id: arrayId(type_of_cooling_system_used),
        position_of_ventilation: structure_detail.position_of_ventilation,
        living_space:
          language == "de"
            ? convertDotToComma(living_space.toString())
            : convertCommaToDot(living_space.toString()),
        // Also load cooling data from needData if available
        next_inspection_date: state?.needData?.next_inspection_date || "",
        number_of_air_conditioning_systems:
          state?.needData?.number_of_air_conditioning_systems ?? 0,
        cooling_capacity: state?.needData?.cooling_capacity || null,
      }));
      // setSubmitData((prev) => ({
      //   ...prev,
      //   average_total_floor_height:
      //     language === "de"
      //       ? convertDotToComma(average_total_floor_height?.toString() ?? "")
      //       : average_total_floor_height,
      //   construction_type,
      //   is_test_for_leaks_conducted,
      //   is_there_cooling_system,
      //   material_id: material ? onlyId(material) : null,
      //   outside_air_exchange,
      //   wing,
      //   ventilation_id: ventilation ? arrayId(ventilation) : null,
      //   type_of_cooling_system_used_id: type_of_cooling_system_used
      //     ? arrayId(type_of_cooling_system_used)
      //     : null,
      //   living_space:
      //     language === "de"
      //       ? convertDotToComma(living_space?.toString() ?? "")
      //       : convertCommaToDot(living_space?.toString() ?? ""),
      // }));

      setStruct((prev) => {
        let updatedWallDetails;

        if (structure_type === 1) {
          updatedWallDetails = wall_details.slice(0, 2); // Limit to 2 items
        } else if (structure_type === 5) {
          updatedWallDetails = wall_details; // Keep as is
        } else {
          updatedWallDetails = wall_details.slice(0, 4); // Limit to 4 items
        }
        const newDataUpdated = updatedWallDetails.map((item, index) => {
          return { ...item, length: convertDotToComma(item.length.toString()) };
        });
        return {
          ...prev,
          id: structure_type,
          wall_details: language == "de" ? newDataUpdated : updatedWallDetails,
        };
      });
      setType(structure_type);
      // setType((prev) => (prev === structure_type ? prev : structure_type));
    } else {
      setStruct(newStructure[0]);
      setType(1);
    }
  }, [state?.walls?.structure_detail]);

  useEffect(() => {
    if (state?.needData && Object.keys(state.needData).length > 0) {
      const {
        next_inspection_date,
        number_of_air_conditioning_systems,
        cooling_capacity,
      } = state.needData;

      // Only update if we have actual values from the backend
      if (
        next_inspection_date !== undefined ||
        number_of_air_conditioning_systems !== undefined ||
        cooling_capacity !== undefined
      ) {
        setSubmitData((prev) => ({
          ...prev,
          next_inspection_date: next_inspection_date || "",
          number_of_air_conditioning_systems:
            number_of_air_conditioning_systems ?? 0,
          cooling_capacity: cooling_capacity || null,
        }));
      }
    }
  }, [
    state?.needData?.next_inspection_date,
    state?.needData?.number_of_air_conditioning_systems,
    state?.needData?.cooling_capacity,
  ]);

  const validateFields = () => {
    const errors = {};
    let hasErrors = false;
    let _review = review.review;
    // Combine submitData and struct
    let _data = { ...submitData, ...struct, review: _review };
    // Debugging: Log the complete _data object

    // Destructure to exclude keys that need to be skipped
    const { type_of_cooling_system_used_id, outside_air_exchange, ...data } =
      _data;

    // Array of keys to skip validation
    const skipKeys = [
      "type_of_cooling_system_used_id",
      "outside_air_exchange",
      "is_there_cooling_system", // Add any other keys you want to skip
      "is_test_for_leaks_conducted",
      "living_space",
      "next_inspection_date",
      "number_of_air_conditioning_systems",
      "cooling_capacity",
    ];

    // Iterate over each key in the data object
    for (const key in data) {
      // Debugging: Log the key being checked

      // Skip validation for specified keys
      if (key === "living_space" && data[key] != null) {
        if (data[key] === "") continue;
        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          let newVal = data[key].toString();
          newVal = convertCommaToDot(newVal.toString()); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !regex.test(data[key]) || // Validate format: digits, optional comma
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.required_field_error;
            hasErrors = true;
          }
        } else {
          const newVal = data[key].toString(); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !/^\d+(\.\d+)?$/.test(newVal) || // Regex to validate numbers and decimals
            parseFloat(newVal) < 0 // Check range: >= 0
          ) {
            errors[key] = needLanguage.required_field_error;
            hasErrors = true;
          }
        }
      }
      if (skipKeys.includes(key)) {
        continue;
      }

      if (
        key === "position_of_ventilation" &&
        !submitData.ventilation_id.some((id) => id === 4 || id === 3)
      ) {
        continue;
      }

      if (Array.isArray(data[key])) {
        // Check if the array is empty
        if (data[key].length === 0) {
          if (key == "review") {
            if (type == 5) {
              errors[key] = needLanguage.required_field_error;
              hasErrors = true;
            }
          } else {
            if (type != 5) {
              errors[key] = needLanguage.required_field_error;
              hasErrors = true;
            }
          }
        } else {
          let errorArray = [];

          // Iterate through the nested arrays of objects
          data[key].forEach((item, index) => {
            let errorObj = { index, errors: {} }; // Prepare an object to store errors for each item
            let hasErrorForItem = false;

            for (const subKey in item) {
              if (subKey === "length") {
                const value = item[subKey]; // Current value to validate
                // Check for null, empty string, or false
                if (value === null || value === "" || value === false) {
                  errorObj.errors[subKey] = needLanguage.required_field_error; // Record the error
                  hasErrorForItem = true;
                  hasErrors = true;
                  continue;
                }

                // Validation for non-null values
                const newValue = convertCommaToDot(value.toString()); // Convert commas to dots for numeric validation

                if (language === "de") {
                  const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
                  if (
                    !regex.test(value) || // Validate format
                    parseFloat(newValue) < 0 // Validate range: must be >= 0
                  ) {
                    errorObj.errors[subKey] = needLanguage.required_field_error; // Record the error
                    hasErrorForItem = true;
                    hasErrors = true;
                  }
                } else {
                  const regex = /^\d+(\.\d+)?$/; // Matches numbers with decimals (dot notation)
                  if (
                    !regex.test(value) || // Validate format
                    parseFloat(value) < 0 // Validate range: must be >= 0
                  ) {
                    errorObj.errors[subKey] = needLanguage.required_field_error; // Record the error
                    hasErrorForItem = true;
                    hasErrors = true;
                  }
                }
              }
            }

            // If there are errors for the item, add the error object to the array
            if (hasErrorForItem) {
              errorArray.push(errorObj);
            }
          });
          if (errorArray.length > 0) errors.wall_details = errorArray;
        }
      } else if (
        data[key] === null ||
        data[key] === "" ||
        data[key] === false
      ) {
        // Check if the value is null, empty string, or false
        errors[key] = needLanguage.required_field_error;
        hasErrors = true;
      } else if (
        key === "average_total_floor_height" ||
        key === "living_space"
      ) {
        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          let newVal = data[key].toString();
          newVal = convertCommaToDot(newVal.toString()); // Convert comma to dot for further validation
          const regex1 = /^([0-5](\.\d+)?|0(\.\d+)?)$/;

          if (
            typeof newVal !== "string" || // Ensure input is a string
            !regex.test(data[key]) || // Validate format: digits, optional comma
            parseFloat(newVal) < 0 || // Check range: >= 0
            !regex1.test(newVal)
          ) {
            errors[key] = needLanguage.required_field_error;
            hasErrors = true;
          }
        } else {
          const regex1 = /^(?:[1-4](?:\.\d*)?|5(?:\.0*)?)$/;
          const newVal = data[key].toString(); // Convert comma to dot for further validation
          if (
            typeof newVal !== "string" || // Ensure input is a string
            !/^\d+(\.\d+)?$/.test(newVal) || // Regex to validate numbers and decimals
            parseFloat(newVal) < 0 || // Check range: >= 0
            !regex1.test(newVal)
          ) {
            errors[key] = needLanguage.required_field_error;
            hasErrors = true;
          }
        }
      }
      if (key === "average_total_floor_height") {
        let newVal = data[key].toString();

        const value = parseFloat(newVal);

        if (value > 5) {
          errors[key] = needLanguage.height_val; // Add custom error for > 5
          hasErrors = true;
        }
      }
    }

    if (
      submitData?.is_there_cooling_system == "true" ||
      submitData?.is_there_cooling_system == true
    ) {
      if (
        submitData?.type_of_cooling_system_used_id?.length === 0 ||
        submitData?.type_of_cooling_system_used_id?.length === null
      ) {
        errors["type_of_cooling_system_used_id"] = needLanguage.select_option;
        hasErrors = true;
      }
      if (
        submitData?.cooling_capacity == "" ||
        submitData?.cooling_capacity == null
      ) {
        errors["cooling_capacity"] = needLanguage.required_field_error;
        hasErrors = true;
      }
    }

    // Log the errors (or handle them as needed)
    setErrorsData(errors);

    // Return true if there are errors
    return hasErrors;
  };
  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        const errors = validateFields();
        if (errors) return;
        const {
          material_id,
          construction_type,
          wing,
          average_total_floor_height,
          living_space,
          is_there_cooling_system,
          type_of_cooling_system_used_id,
          is_test_for_leaks_conducted,
          outside_air_exchange,
          ventilation_id,
          number_of_air_conditioning_systems,
          cooling_capacity,
          next_inspection_date,
          position_of_ventilation,
        } = submitData;
        let wallsData = struct?.wall_details?.map((item) => {
          const { image, ...rest } = item; // Destructure properly
          return {
            ...rest,
            img: image,
            length: convertCommaToDot(item.length),
          }; // Return the updated object
        });
        const _data = {
          material_id: material_id,
          structure_type: struct.id,
          construction_type: construction_type,
          wing: wing,
          average_total_floor_height: convertCommaToDot(
            average_total_floor_height
          ),
          ...(living_space && {
            living_space: convertCommaToDot(living_space),
          }),
          is_there_cooling_system: is_there_cooling_system,
          is_test_for_leaks_conducted: is_test_for_leaks_conducted,
          // outside_air_exchange: outside_air_exchange,
          ...(outside_air_exchange && {
            outside_air_exchange: outside_air_exchange,
          }),
          ...(type_of_cooling_system_used_id && {
            type_of_cooling_system_used_id: type_of_cooling_system_used_id,
          }),
          ...(ventilation_id?.some((id) => id === 4 || id === 3) && {
            position_of_ventilation,
          }),
          wall_details: struct.id == 5 ? [] : wallsData,
          ventilation_id: ventilation_id,
          ...(notes && { notes: notes }),
        };

        try {
          const postData = await PatchApi(`/energy_need/${state.needId}/`, {
            structure_detail: _data,
            ...(is_there_cooling_system && {
              next_inspection_date: next_inspection_date
                ? stringToYYYYMMDD(next_inspection_date)
                : null,
              cooling_capacity: cooling_capacity,
              number_of_air_conditioning_systems:
                number_of_air_conditioning_systems,
            }),
            language: language === "de" ? 2 : 1,
          });
          if (postData.status === 200 || postData.status === 201) {
            const {
              structure_detail,
              cooling_capacity,
              number_of_air_conditioning_systems,
              next_inspection_date,
            } = postData.data.data;
            setState((prev) => ({
              ...prev,
              needPage: prev.needPage + 1,

              walls: {
                ...prev.walls,
                structure_detail: {
                  ...structure_detail,
                  living_space: living_space,
                },
              },
              needData: {
                ...prev.needData,
                cooling_capacity,
                number_of_air_conditioning_systems,
                next_inspection_date,
              },
              needFilledPage:
                prev.needFilledPage >= 3 ? prev.needFilledPage : 3,
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, needPage: prev.needPage - 1 }));
      } else if (type === "save") {
        await getApi(`/energy_need/${state.needId}/generate_link/`);
        // navigate("/login");
        setResponse(true);
      }
    } catch (error) {
      console.log(error, "errorerror");
      HandleErrorPop(true);
    }
  };
  useEffect(() => {
    if (type > 5) {
      setStruct({ id: null, wall_details: [] });
    } else {
      // setStruct(newStructure[type - 1]);
    }
  }, [type]);
  // useEffect(() => {
  //   if (type == 5) {
  //     const arrayOfObjects = Array.from({ length: corners }, (_, i) => ({
  //       length: null,
  //       index: i + 1,
  //     }));
  //     setStruct({ id: Number(type), wall_details: [] });
  //   }
  // }, [type, corners]);
  const handleChange = (e, _id) => {
    const { name, value } = e.target;
    if (
      name === "Rectangle" ||
      name === "L-Form" ||
      name === "T-Form" ||
      name === "U-Form" ||
      name === "Custom"
    ) {
      setType(value);
      if (name === "Custom") {
        setStruct({ id: 5, wall_details: [] });
      } else {
        setStruct(newStructure[_id - 1]);
      }
    } else {
      setSubmitData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const getList = async () => {
    try {
      const ven = await getApi(`/energy_consumption/ventilation`);
      const mat = await getApi(
        `/energy_need/material_types?type=1&year=${state?.needData.construction_year}`
      );
      const source = await getApi(`/energy_consumption/energy_source`);
      const coolingCapacity = await getApi(
        `/energy_consumption/cooling_capacity_types`
      );

      // const cool = await getApi(`/energy_consumption/colling_system_types`);
      // const renew = await getApi(`/energy_consumption/renewable_energy_types`);
      // const renewFor = await getApi(`/energy_consumption/renewable_energy_for`);
      setVentaltion(ven.data.data);
      setMaterial(mat.data.data);
      setCoolingData(coolingCapacity?.data?.data ?? []);
      // setCoolings(cool.data.data);
      // setRenewable(renew.data.data);
      // setRenewableFor(renewFor.data.data);
      setDisableNext(false);
    } catch (error) {}
  };
  useEffect(() => {
    getList();
    window.scroll(0, 0);
  }, []);
  const handleCheckboxChange = (name, checkedIds) => {
    if (name === "ventilation_id") {
      setSubmitData((prev) => ({ ...prev, ventilation_id: checkedIds }));
    } else if (name === "type_of_cooling_system_used_id") {
      setSubmitData((prev) => ({
        ...prev,
        type_of_cooling_system_used_id: checkedIds,
      }));
    } else if (name === "review") {
      setReview({ review: checkedIds });
    }
  };
  const handleChangeButton = (e, index) => {
    // setData(prev=>({...prev,heating_info:}))
    const { value, name } = e.target; // Get the input value

    setStruct((prevData) => {
      // Make a copy of the previous state
      const newData = prevData.wall_details;
      newData[index][name] = value;
      return { ...prevData, wall_details: newData }; // Return the updated array
      // Update the specific field of the object at the given index
      // newData[index] = { ...newData[index], [name]: value };
      // return { ...prevData, [field]: newData }; // Return the updated array
    });

    // setStruct((prevData) => ({
    //   ...prevData,
    //   wall_details: prevData.wall_details.map((item, i) =>
    //     i === index ? { ...item, [name]: value } : item
    //   ),
    // }));
  };

  const popData = {
    avg: [
      {
        heading: needLanguage.avg_height,
        para1: needLanguage.avg_height_info,
      },
    ],
    space: [
      {
        heading: needLanguage.living_sp,
        para1: needLanguage.living_sp_info1,
        para2: needLanguage.living_sp_info2,
      },
    ],
    con: [
      {
        heading: needLanguage.type_con,
        para1: needLanguage.type_con_info,
      },
    ],
    material: [
      {
        heading: needLanguage.material,
        para1: needLanguage.material_info1,

        para2: needLanguage.material_info2,
        // para3: needLanguage.building_d3,
      },
    ],
    part: [
      {
        heading: needLanguage.part_of_build,
        para1: needLanguage.part_of_build_info,
      },
    ],
    ventilation: [
      {
        heading: needLanguage.type_ventilation,
        para1: needLanguage.type_ventilation_info,
      },
    ],
    colling: [
      {
        heading: needLanguage.colling,
        para1: needLanguage.colling_info,
      },
    ],
    door: [
      {
        heading: needLanguage.door_test,
        para1: needLanguage.door_test_info,
      },
    ],
  };
  const CustomFormControlLabel = styled(FormControlLabel)({
    margin: 0, // Remove all margin
  });

  const handleChangeINput = (e) => {
    const { name, value } = e.target;
    setSubmitData({
      ...submitData,
      [name]: value,
    });
  };

  const handleChangeDate = (name, e) => {
    setSubmitData({
      ...submitData,
      [name]: e,
    });
  };

  return (
    <div>
      <div className={styles.con}>
        {" "}
        <StepsHeader
          image={structure}
          heading={needLanguage.structure_details}
          secPara={needLanguage.provided_information}
        />
        <div className={styles.fieldDetails}>
          <p>{needLanguage.structure_details_para}</p>
          <p>
            <b>{needLanguage.note}:</b>{" "}
            {needLanguage.structure_details_para_note}
          </p>
          <p>{needLanguage.as_per_your_floor_plan}</p>
          <div className={styles.fieldDetailsCon}>
            <div
              className={styles.Radio}
              style={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {structure_type.map((item, index) => {
                return (
                  <FormControl>
                    <RadioGroup
                      name={item.title} // Name of the radio group
                      value={type}
                      onChange={(e) => handleChange(e, item.id)} // Handle value changes
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "100%",
                        }}
                      >
                        <div>
                          <img
                            src={language === "de" ? item.img_german : item.img}
                            className={styles.imageClass}
                          />
                        </div>
                        <div style={{ textAlign: "center", margin: "auto" }}>
                          <CustomFormControlLabel
                            value={item.id}
                            control={<Radio />}
                            // label="yes"
                          />
                        </div>
                      </div>
                    </RadioGroup>
                  </FormControl>
                );
              })}
            </div>
            <div>
              {/* {type == 5 && (
                <div className={styles.fieldCom}>
                  <p className={styles.fieldName} style={{ marginTop: "11px" }}>
                    Corners
                  </p>
                  <TextField
                    style={{ width: "100%" }}
                    size="small"
                    value={corners}
                    name="corners"
                    onChange={(e) => {
                      setCorners(e.target.value);
                    }}
                  />
                </div>
              )} */}
              <div className={styles.fieldCom}>
                {/* {struct.wall_details.map((item1, index1) => {
                  const value = item1.length ? item1.length : "";
                  const letter = String.fromCharCode(65 + index1); // 65 is the ASCII code for 'A'
                  if (type != 5) return;
                  return (
                    <div className={styles.fields}>
                      <p
                        className={styles.fieldName}
                        style={{ marginTop: "11px" }}
                      >
                        {needLanguage.wall_length} {letter}
                      </p>
                      <TextField
                        onChange={(e) => handleChangeButton(e, index1)}
                        showInfo={false}
                        style={{ width: "100%" }}
                        value={value}
                        name="length"
                        onWheel={(e) => e.target.blur()}
                        size="small"
                        endIcon="meter"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">m</InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  );
                })} */}
              </div>
              {struct.wall_details.map((item1, index1) => {
                const value = item1.length ? item1.length : "";
                const letter = String.fromCharCode(65 + index1); // 65 is the ASCII code for 'A'
                const error = errorsData.hasOwnProperty("wall_details")
                  ? errorsData?.wall_details?.find((fil, indx) => {
                      return fil.index === index1;
                    })
                  : "";
                if (type == 5) return;
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "15px",
                    }}
                    key={item1.index}
                  >
                    <div style={{ width: "20%" }}>
                      <img
                        src={item1.img ? item1.img : item1.image}
                        className={styles.indiImage}
                      />
                    </div>
                    <div style={{ width: "100%" }}>
                      <p
                        className={styles.fieldName}
                        style={{ marginTop: "11px" }}
                      >
                        {needLanguage.wall_length} {letter}
                      </p>
                      <TextField
                        onChange={(e) => handleChangeButton(e, index1)}
                        showInfo={false}
                        style={{ width: "100%" }}
                        value={value}
                        onWheel={(e) => e.target.blur()}
                        name="length"
                        size="small"
                        endIcon="meter"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">m</InputAdornment>
                          ),
                        }}
                        error={error?.errors?.length}
                        helperText={error?.errors?.length}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {type == 5 && (
            <div
              style={{
                textAlign: "center",
                background: "#EFF8D4",
                padding: "20px",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <p>{needLanguage.custom_info}</p>
                <Button
                  variant="contained"
                  sx={{
                    padding: "12px 25px",
                    background:
                      " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                    boxShadow: "none",
                    borderRadius: "10px",
                    color: "white",
                    "&:disabled": {
                      background: "gray",
                      color: "#ccc",
                    },
                  }}
                  onClick={() => setOpenDialog(true)}
                >
                  {needLanguage?.Documents_notes_btn}
                </Button>
              </div>
              <div style={{ textAlign: "left", marginTop: "10px" }}>
                <CustomCheckBox
                  data={data}
                  name="review"
                  onCheckChange={handleCheckboxChange}
                  selectedValues={review.review}
                />
              </div>
              <p style={{ color: "#d32f2f", fontSize: "12px" }}>
                {errorsData.review}
              </p>
            </div>
          )}
          <div className={styles.fieldCom}>
            <div className={styles.fields}>
              <p className={styles.fieldName} style={{ marginTop: "11px" }}>
                {needLanguage.total_floor_height}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.avg)}
                />
              </p>
              <TextField
                style={{ width: "100%" }}
                size="small"
                value={submitData.average_total_floor_height}
                name="average_total_floor_height"
                onWheel={(e) => e.target.blur()}
                onChange={handleChange}
                error={errorsData?.average_total_floor_height}
                helperText={errorsData?.average_total_floor_height}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">m</InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName} style={{ marginTop: "11px" }}>
                {needLanguage.living_space}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.space)}
                />
              </p>
              <TextField
                style={{ width: "100%" }}
                size="small"
                value={submitData.living_space}
                name="living_space"
                onChange={handleChange}
                error={errorsData?.living_space}
                helperText={errorsData?.living_space}
                onWheel={(e) => e.target.blur()}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {needLanguage.sqm}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {needLanguage.construction_type}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.con)}
                />
              </p>
              <FormControl
                fullWidth
                error={Boolean(errorsData.construction_type)}
              >
                <Select
                  size="small"
                  value={submitData.construction_type ?? ""}
                  name="construction_type"
                  onChange={(e) => handleChange(e)}
                >
                  {constructionType.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {selectedLanguage(option, language)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errorsData?.construction_type && (
                <FormHelperText error={errorsData.construction_type}>
                  {errorsData?.construction_type}
                </FormHelperText>
              )}
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {needLanguage.material_used}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.material)}
                />
              </p>
              <FormControl fullWidth error={Boolean(errorsData.material_id)}>
                <Select
                  size="small"
                  value={submitData.material_id ?? ""}
                  name="material_id"
                  onChange={(e) => handleChange(e)}
                >
                  {material.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {selectedLanguage(option, language)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errorsData?.material_id && (
                <FormHelperText error={errorsData.material_id}>
                  {errorsData?.material_id}
                </FormHelperText>
              )}
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {needLanguage.part_the_building}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.part)}
                />
              </p>
              <FormControl fullWidth error={Boolean(errorsData.wing)}>
                <Select
                  size="small"
                  value={submitData.wing ?? ""}
                  name="wing"
                  onChange={(e) => handleChange(e)}
                >
                  {wing.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {selectedLanguage(option, language)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errorsData?.wing && (
                <FormHelperText error={errorsData.wing}>
                  {errorsData?.wing}
                </FormHelperText>
              )}
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName} style={{ marginTop: "15px" }}>
                {needLanguage.type_of_ventilation}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.ventilation)}
                />
                {/* <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.ventilation)}
                /> */}
              </p>
              {errorsData?.ventilation_id && (
                <FormHelperText error={errorsData.ventilation_id}>
                  {errorsData?.ventilation_id}
                </FormHelperText>
              )}
              {ventilation.length > 0 && (
                <CustomCheckBox
                  data={ventilation}
                  name="ventilation_id"
                  onCheckChange={handleCheckboxChange}
                  selectedValues={submitData.ventilation_id}
                />
              )}
            </div>
            {submitData?.ventilation_id.some((id) => id === 4 || id === 3) && (
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {needLanguage.position_of_ventilation}
                </p>
                <FormControl
                  fullWidth
                  error={Boolean(errorsData.position_of_ventilation)}
                >
                  <Select
                    size="small"
                    value={submitData.position_of_ventilation ?? ""}
                    name="position_of_ventilation"
                    onChange={(e) => handleChange(e)}
                  >
                    {position_of_ventilation_system.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {selectedLanguage(option, language)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorsData?.position_of_ventilation && (
                  <FormHelperText error={errorsData.position_of_ventilation}>
                    {errorsData?.position_of_ventilation}
                  </FormHelperText>
                )}
              </div>
            )}
          </div>
          <div className={styles.fieldDetailsCon}>
            <p className={styles.fieldName}>
              {needLanguage.cooling_system}
              <img
                src={info}
                style={{ cursor: "pointer" }}
                onClick={() => handlePopUp(popData?.colling)}
              />
            </p>
            <RadioGroup
              name="is_there_cooling_system" // Name of the radio group
              value={submitData.is_there_cooling_system} // Bind the state value
              onChange={handleChange} // Handle value changes
            >
              <div className={styles.Radio}>
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label={needLanguage.yes}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label={needLanguage.no}
                />
              </div>
            </RadioGroup>
            {(submitData.is_there_cooling_system == "true" ||
              submitData.is_there_cooling_system == true) && (
              <>
                {errorsData?.type_of_cooling_system_used_id && (
                  <FormHelperText
                    error={errorsData.type_of_cooling_system_used_id}
                  >
                    {errorsData?.type_of_cooling_system_used_id}
                  </FormHelperText>
                )}
                <CustomCheckBox
                  data={coolingSystem}
                  name="type_of_cooling_system_used_id"
                  onCheckChange={handleCheckboxChange}
                  selectedValues={submitData.type_of_cooling_system_used_id}
                />
                <div className={styles.fieldCom}>
                  <p className={styles.fieldName}>
                    {needLanguage?.number_of_air_conditioning_systems}
                  </p>
                  <div style={{ width: "100%", display: "flex", gap: "10px" }}>
                    <Select
                      style={{ width: "48%" }}
                      size="small"
                      value={submitData?.number_of_air_conditioning_systems}
                      onChange={(e) => handleChangeINput(e)}
                      name="number_of_air_conditioning_systems"
                    >
                      {numberOfColling?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className={styles.fieldCom}>
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage?.cooling_capacity}
                    </p>
                    <Select
                      style={{ width: "100%" }}
                      size="small"
                      value={submitData?.cooling_capacity}
                      onChange={(e) => handleChangeINput(e)}
                      name="cooling_capacity"
                      error={errorsData?.cooling_capacity}
                    >
                      {coolingData?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {selectedLanguage(option, language)}
                        </MenuItem>
                      ))}
                    </Select>
                    {errorsData?.cooling_capacity && (
                      <FormHelperText error={errorsData.cooling_capacity}>
                        {errorsData?.cooling_capacity}
                      </FormHelperText>
                    )}
                  </div>
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage?.next_inspection_date}
                    </p>
                    <div style={{ width: "90%" }}>
                      <DateField
                        name="next_inspection_date"
                        startDate={submitData.next_inspection_date}
                        max={true}
                        style={{ width: "80%" }}
                        onChange={(e) =>
                          handleChangeDate("next_inspection_date", e)
                        }
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* <RadioGroup
              name="type_of_cooling_system_used" // Name of the radio group
              value={submitData.type_of_cooling_system_used} // Bind the state value
              onChange={handleChange} // Handle value changes
            >
              <div className={styles.Radio1}>
                {coolingSystem.map((item, index) => {
                  return (
                    <FormControlLabel
                      value={`${item.id}`}
                      control={<Radio />}
                      label={item.title}
                    />
                  );
                })}
              </div>
            </RadioGroup> */}
          </div>
          <div className={styles.fieldDetailsCon}>
            <p className={styles.fieldName}>
              {needLanguage.has_leaks_been_conducted}{" "}
              <img
                src={info}
                style={{ cursor: "pointer" }}
                onClick={() => handlePopUp(popData?.door)}
              />
              {/* <span style={{ fontWeight: "400" }}>(Blower door Test)</span>? */}
            </p>
            <RadioGroup
              name="is_test_for_leaks_conducted" // Name of the radio group
              value={submitData.is_test_for_leaks_conducted} // Bind the state value
              onChange={handleChange} // Handle value changes
            >
              <div className={styles.Radio}>
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label={needLanguage.yes}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label={needLanguage.no}
                />
              </div>
            </RadioGroup>
            {/* {submitData.is_test_for_leaks_conducted && (
              <div className={styles.fields}>
                <CustomCheckBox
                  data={outsideAir}
                  name="outside_air_exchange"
                  onCheckChange={handleCheckboxChange}
                  selectedValues={submitData.outside_air_exchange}
                />
              </div>
            )} */}
            {(submitData.is_test_for_leaks_conducted == "true" ||
              submitData.is_test_for_leaks_conducted == true) && (
              <RadioGroup
                name="outside_air_exchange" // Name of the radio group
                value={submitData.outside_air_exchange} // Bind the state value
                onChange={handleChange} // Handle value changes
              >
                <div className={styles.Radio1}>
                  {outsideAir.map((item, index) => {
                    return (
                      <FormControlLabel
                        value={item.id}
                        control={<Radio />}
                        label={selectedLanguage(item, language)}
                      />
                    );
                  })}
                </div>
              </RadioGroup>
            )}
          </div>{" "}
        </div>
        <DialogAdd
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setNotes={setNotes}
          notes={notes}
        />
        {pop && (
          <PopUpInfo
            handleClose={() => setPop(false)}
            open={pop}
            data={infoText}
          />
        )}
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        setResponse={setResponse}
        disabled={disableNext}
      />
    </div>
  );
}

export default Step2;

const wallDetails = [
  {
    length: 20,

    index: 1,
  },

  {
    length: 10,

    index: 2,
  },

  {
    length: 10,

    index: 3,
  },

  {
    length: 10,

    index: 4,
  },
];

const data = [
  {
    german_title: needCertificateGerText.custom_agree,
    title: needCertificateEngText.custom_agree,
    id: 1,
  },
];

const position_of_ventilation_system = [
  {
    id: 1,
    title: "Within the thermal Envelope",
    german_title: "Innerhalb der thermischen Umhüllung",
  },
  {
    id: 2,
    title: "Roof Outside Thermal Envelope",
    german_title: "Dach außerhalb der thermischen Hülle",
  },
  {
    id: 3,
    title: "Basement Outside Thermal Envelope",
    german_title: "Untergeschoss außerhalb der thermischen Hülle",
  },
];
